// src/pages/SummaryPage.js
import React, { useState, useEffect } from 'react'; // Hapus useCallback
import SummaryTable from '../components/SummaryTable';
import { useAuth } from '../context/AuthContext';

// Fungsi untuk membuat daftar bulan (tidak berubah)
const generateMonthOptions = () => {
//  const options = [];
//  const d = new Date();
//  for (let i = 0; i < 12; i++) {
//    const month = d.toISOString().slice(0, 7);
//    const label = d.toLocaleString('default', { month: 'long', year: 'numeric' });
//    options.push({ value: month, label: label });
//    d.setMonth(d.getMonth() - 1);
//  }
//  return options;

// Edited by Kopp
   const options = [];
   const d = new Date();
   for (let i = 0; i < 12; i++) {
     const year = d.getFullYear();
     const month = String(d.getMonth() + 1).padStart(2, '0'); // 1–12 → "01"–"12"
     options.push({
       value: `${year}-${month}`,
       label: d.toLocaleString('default', { month: 'long', year: 'numeric' })
     });
     d.setMonth(d.getMonth() - 1);
   }
   return options;
};

const options = {
  timeZone: 'Asia/Jakarta',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

function formatDateToISO(date) {
  const formattedDate = new Intl.DateTimeFormat('en-GB', options).format(date);
  const [day, month, year] = formattedDate.split('/');
  return `${year}-${month}-${day}`;
}

function SummaryPage() { // Halaman tabel
  const [summaryData, setSummaryData] = useState({ deposit_summary: [], disbursement_summary: [] });
  const [loading, setLoading] = useState(true);
  const auth = useAuth();
  
  const [showAverage, setShowAverage] = useState(false);
  const [showFee, setShowFee] = useState(false);
  const [filterType, setFilterType] = useState('monthly'); // 'monthly' or 'daily'
  const [selectedMonth, setSelectedMonth] = useState('');
  const monthOptions = generateMonthOptions();
  
  // Daily filter states
  // const today = new Date().toISOString().slice(0, 10);
  // const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10);
const getToday = new Date();
const getFirstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
const today = formatDateToISO(getToday);
const firstDayOfMonth = formatDateToISO(getFirstDayOfMonth);
  const [startDate, setStartDate] = useState(firstDayOfMonth);
  const [endDate, setEndDate] = useState(today);

  // Fungsi fetch data biasa
  const fetchSummaryData = async () => {
    try {
      setLoading(true);
      let apiUrl = '/api/summary';
      
      // Build query parameters based on filter type
      if (filterType === 'daily') {
        apiUrl += `?start_date=${startDate}&end_date=${endDate}`;
      } else if (filterType === 'monthly' && selectedMonth) {
        apiUrl += `?month=${selectedMonth}`;
      }
      
      const response = await auth.authFetch(apiUrl);
      const data = await response.json();
      setSummaryData(data);
    } catch (error) {
      console.error("Gagal mengambil data summary:", error);
    } finally {
      setLoading(false);
    }
  };

  // useEffect berjalan HANYA SEKALI saat komponen dimuat
  useEffect(() => {
    fetchSummaryData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // <-- Array dependensi SENGAJA dikosongkan untuk menghentikan loop

  // Handler untuk tombol filter manual
  const handleApplyFilter = () => {
    fetchSummaryData();
  };

  return (
    <div>
      <div className="dashboard-header">
        <h1>Summary</h1>
        <div className="month-filter" style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
          {/* Filter Type Selector */}
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <label>
              <input 
                type="radio" 
                value="monthly" 
                checked={filterType === 'monthly'} 
                onChange={(e) => setFilterType(e.target.value)}
              />
              {' '}Bulanan
            </label>
            <label>
              <input 
                type="radio" 
                value="daily" 
                checked={filterType === 'daily'} 
                onChange={(e) => setFilterType(e.target.value)}
              />
              {' '}Harian
            </label>
          </div>
          
          {/* Monthly Filter */}
          {filterType === 'monthly' && (
            <select 
              value={selectedMonth} 
              onChange={(e) => setSelectedMonth(e.target.value)}
            >
              <option value="">Semua Bulan</option>
              {monthOptions.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          )}
          
          {/* Daily Filter */}
          {filterType === 'daily' && (
            <>
              <input 
                type="date" 
                value={startDate} 
                onChange={(e) => setStartDate(e.target.value)}
              />
              <input 
                type="date" 
                value={endDate} 
                onChange={(e) => setEndDate(e.target.value)}
              />
            </>
          )}
          
          {/* Apply Button */}
          <button onClick={handleApplyFilter}>Apply</button>
        </div>
      </div>

      {loading ? (
        <div>Loading summary...</div>
      ) : (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <h2 style={{ margin: 0 }}>Deposit Summary</h2>
            
            <div style={{ display: 'flex', gap: '20px' }}>
              {/* Toggle Fee Display - Slider Style */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ fontSize: '14px', fontWeight: '500' }}>Show Fee:</span>
                <label style={{ 
                  position: 'relative', 
                  display: 'inline-block', 
                  width: '50px', 
                  height: '24px',
                  cursor: 'pointer'
                }}>
                  <input 
                    type="checkbox" 
                    checked={showFee} 
                    onChange={(e) => setShowFee(e.target.checked)}
                    style={{ opacity: 0, width: 0, height: 0 }}
                  />
                  <span style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: showFee ? '#FF9800' : '#ccc',
                    borderRadius: '24px',
                    transition: 'background-color 0.3s',
                    cursor: 'pointer'
                  }}>
                    <span style={{
                      position: 'absolute',
                      content: '',
                      height: '18px',
                      width: '18px',
                      left: showFee ? '28px' : '3px',
                      bottom: '3px',
                      backgroundColor: 'white',
                      borderRadius: '50%',
                      transition: 'left 0.3s',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}></span>
                  </span>
                </label>
                <span style={{ 
                  fontSize: '14px', 
                  fontWeight: 'bold',
                  color: showFee ? '#FF9800' : '#999',
                  minWidth: '35px'
                }}>
                  {showFee ? 'ON' : 'OFF'}
                </span>
              </div>

              {/* Toggle Average Display - Slider Style */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ fontSize: '14px', fontWeight: '500' }}>Show Average:</span>
                <label style={{ 
                  position: 'relative', 
                  display: 'inline-block', 
                  width: '50px', 
                  height: '24px',
                  cursor: 'pointer'
                }}>
                  <input 
                    type="checkbox" 
                    checked={showAverage} 
                    onChange={(e) => setShowAverage(e.target.checked)}
                    style={{ opacity: 0, width: 0, height: 0 }}
                  />
                  <span style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: showAverage ? '#4CAF50' : '#ccc',
                    borderRadius: '24px',
                    transition: 'background-color 0.3s',
                    cursor: 'pointer'
                  }}>
                    <span style={{
                      position: 'absolute',
                      content: '',
                      height: '18px',
                      width: '18px',
                      left: showAverage ? '28px' : '3px',
                      bottom: '3px',
                      backgroundColor: 'white',
                      borderRadius: '50%',
                      transition: 'left 0.3s',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}></span>
                  </span>
                </label>
                <span style={{ 
                  fontSize: '14px', 
                  fontWeight: 'bold',
                  color: showAverage ? '#4CAF50' : '#999',
                  minWidth: '35px'
                }}>
                  {showAverage ? 'ON' : 'OFF'}
                </span>
              </div>
            </div>
          </div>
          
          <SummaryTable
            title="Deposit Summary"
            data={summaryData.deposit_summary}
            showAverage={showAverage}
            showFee={showFee}
          />
          
          <h2>Disbursement Summary</h2>
          <SummaryTable
            title="Disbursement Summary"
            data={summaryData.disbursement_summary}
            showAverage={showAverage}
            showFee={false}
          />
        </>
      )}
    </div>
  );
}

export default SummaryPage;
